<template>
  <icon-base
    v-if="expanded"
    height="21"
    width="21"
    :icon="IconShrink"
    icon-color="none"
    icon-name="Shrink"
  />
  <icon-base
    v-else
    height="21"
    width="21"
    :icon="IconExpand"
    icon-color="none"
    icon-name="Expand"
  />
</template>
<script type="text/javascript">
import IconExpand from "@/components/icons/IconExpand.vue";
import IconShrink from "@/components/icons/IconShrink.vue";

export default {
  name: "ExpandButton",
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { IconExpand, IconShrink };
  },
};
</script>
